import { useTranslation } from 'react-i18next';
import buttonCSS from 'components/styles/button';
import { useState } from 'react';
import Heart from 'components/Heart';
import css from 'styled-jsx/css';
import { trackRemoveFavorite } from 'lib/Tracking/FavoritesPage';
import { useDispatch } from 'react-redux';
import { removeFavorite } from 'redux-implementations/favorites';
import CardInfo from '../CardInfo';
import styles from './styles';

export interface InactiveFavoriteCardProps {
  id: number;
  vin: string;
  make: string;
  model: string;
  trim: string;
  year: number;
  mileage: string;
  price: string;
  city: string;
  state: string;
  monthlyPayment?: number;
  thumbnailImg: string;
  isAcceptingOffers: boolean;
}

const heartCss = css.resolve`
  position: absolute;
  top: 12px;
  right: 12px;
`;

const InactiveFavoriteCard = ({
  vin,
  make,
  model,
  year,
  trim,
  mileage,
  price,
  city,
  state,
  monthlyPayment,
  thumbnailImg,
  isAcceptingOffers,
}: InactiveFavoriteCardProps): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [fadeOutClass, setFadeOutClass] = useState('');
  const onHeartClick = (): void => {
    trackRemoveFavorite(vin);
    dispatch(removeFavorite(vin));
    setFadeOutClass('fade-out');
  };

  return (
    <div className={`not-active-card ${fadeOutClass}`} data-testid="inactive-card">
      <div className="image-container">
        <img className="not-active-image" src={thumbnailImg} alt="listing-image" />
        <Heart active={true} className={heartCss.className} onClick={onHeartClick} />
      </div>
      <div className="outer-container">
        <CardInfo
          year={year}
          make={make}
          model={model}
          trim={trim}
          mileage={mileage}
          city={city}
          state={state}
          price={price}
          monthlyPayment={monthlyPayment}
          isAcceptingOffers={isAcceptingOffers}
        />
        <div className="not-available">
          <div className="text">{t('favorites.noLongerAvailable')}</div>
          <button onClick={onHeartClick} className="button" data-testid="remove-button">
            {t('favorites.remove')}
          </button>
        </div>
      </div>

      <style jsx>{styles}</style>
      <style jsx>{buttonCSS}</style>
      {heartCss.styles}
    </div>
  );
};

export default InactiveFavoriteCard;
